import { DASHBOARD } from 'constants/routing'
import { observer } from 'mobx-react-lite'
import { Navigate } from 'react-router'
import User from 'singletons/User'
import ReportCard from './ReportCard'
import { usePqmReportApi } from 'hooks/reports/usePqmReportApi'
import { useMemo } from 'react'

const Reports = () => {
  const { isReportsPageAvailable, isPqmReportAvailable } = User
  const { downloadPqmReport, isLoadingPqmReport } = usePqmReportApi()

  const reports = useMemo(
    () =>
      [
        {
          title: 'PQM Report',
          isHidden: !isPqmReportAvailable,
          onClick: downloadPqmReport,
          isLoading: isLoadingPqmReport,
        },
      ].filter((i) => !i.isHidden),
    [downloadPqmReport, isLoadingPqmReport, isPqmReportAvailable],
  )

  if (!isReportsPageAvailable) {
    return <Navigate to={DASHBOARD} replace />
  }

  return (
    <div className="flex flex-col gap-6 py-12 px-5 flex-1 bg-neutral-900">
      <h2 className="typography-h4 text-neutral-800">Quality Metrics</h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
        {reports.map(({ title, isLoading, onClick }) => (
          <ReportCard key={title} title={title} isLoading={!!isLoading} onClick={onClick} />
        ))}
      </div>
    </div>
  )
}

export default observer(Reports)
